import { AppConfig } from '../app/helpers/config';
import { commonConfig, docsConfig } from './base';

export const environment: AppConfig = Object.assign({}, commonConfig, docsConfig, {
    apiUrl: 'https://docs-api.kaptioapis.com/',
    production: true,
});
